@use '../../styling/colors.scss' as *;

.Overlay {
  // Overlay
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: grid;
  justify-content: center;

  &.AbsoluteCenter {
    // Center the content
    position: absolute;
    align-items: center;
  }

  &.purple {
    background: $color-eggy-face;
  }

  &.default {
    background: none;
  }
}
